import {importProvidersFrom, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AppLayoutModule} from './layout/app.layout.module';
import {CookieService} from "ngx-cookie-service";
import { HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";
import {AuthInterceptor} from "./interceptors/auth.interceptor";
import {DialogModule} from 'primeng/dialog';
import {API_URL, APP_URL, LOGIN_URL, STRIPE_KEY} from "./api.token";
import {environment} from "../environments/environment";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TooltipDirective} from "./shared/directives/tooltip.directive";
import {DialogService} from "primeng/dynamicdialog";


export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,

    ],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            }
        }),
        DialogModule,
        TooltipDirective
    ],
    providers: [
        CookieService,
        DialogService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true // interceptor is added to the chain
        },
        {provide: APP_URL, useValue: environment.appUrl},
        {provide: API_URL, useValue: environment.apiUrl},
        {provide: LOGIN_URL, useValue: environment.loginUrl},
        {provide: STRIPE_KEY, useValue: environment.stripeKey}

    ],

    bootstrap: [AppComponent]
})
export class AppModule {
}
